import { useTranslation } from 'react-i18next'

import { Button, ButtonText, Heading, Tooltip } from '@percent/lemonade'
import styles from './WizardHeader.module.scss'
import { WizardHeaderProps } from './WizardHeader.types'

export function WizardHeader({
  title,
  onCancel,
  onPublish,
  isPublishDisabled,
  isLoading,
  publishBtnCopy,
  toolTipCopy,
  publishBtnTestId,
  cancelBtnTestId
}: Readonly<WizardHeaderProps>) {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <Heading level="h3">{title}</Heading>
      <div className={styles.buttonsWrapper}>
        <ButtonText onClick={onCancel} data-testid={cancelBtnTestId}>
          {t('button.cancel')}
        </ButtonText>
        {isPublishDisabled && !isLoading ? (
          <Tooltip content={toolTipCopy}>
            <div data-testid="wrapper-disabled-confirm-button">
              <Button
                size="small"
                onClick={onPublish}
                disabled={isPublishDisabled}
                loading={isLoading}
                data-testid={publishBtnTestId}
              >
                {publishBtnCopy}
              </Button>
            </div>
          </Tooltip>
        ) : (
          <Button
            size="small"
            onClick={onPublish}
            disabled={isPublishDisabled}
            loading={isLoading}
            data-testid={publishBtnTestId}
          >
            {publishBtnCopy}
          </Button>
        )}
      </div>
    </div>
  )
}
